import { SchedulingFlowRouteName } from '../../../../router/routes/schedulingFlow/model.js';
import { getStore } from '../../../helpers/initStore.js';

// ROOT STEPS
const getSchedulingFlowAddressStepFailures = (_route) => {
    var _a;
    const store = getStore();
    const schedulingFlowState = store.state.schedulingFlow;
    const locationSet = !!((_a = schedulingFlowState.location) === null || _a === void 0 ? void 0 : _a.formattedAddress);
    if (!locationSet)
        return ['Address is required'];
    return null;
};
const getSchedulingFlowFlexibleOptionStepFailures = (_route) => {
    var _a;
    const store = getStore();
    const schedulingFlowState = store.state.schedulingFlow;
    const flexibleSchedulingSet = ((_a = schedulingFlowState.draftWaypoint) === null || _a === void 0 ? void 0 : _a.flexibleScheduling) !== undefined;
    if (!flexibleSchedulingSet)
        return ['Flexible option is required'];
    return null;
};
const getSchedulingFlowDateRangeStepFailures = (_route) => {
    var _a;
    const store = getStore();
    const schedulingFlowState = store.state.schedulingFlow;
    const dateRangeSet = ((_a = schedulingFlowState.draftWaypoint) === null || _a === void 0 ? void 0 : _a.dateRange) !== undefined;
    if (!dateRangeSet)
        return ['Date range is required'];
    return null;
};
const getSchedulingFlowTimeRangeStepFailures = (_route) => {
    var _a, _b;
    const store = getStore();
    const schedulingFlowState = store.state.schedulingFlow;
    const timeRangeSet = ((_b = (_a = schedulingFlowState.draftWaypoint) === null || _a === void 0 ? void 0 : _a.timeRange) !== null && _b !== void 0 ? _b : []).length > 0;
    if (!timeRangeSet)
        return ['Time range is required'];
    return null;
};
const getSchedulingFlowTimeStepFailures = (_route) => {
    const store = getStore();
    const schedulingFlowState = store.state.schedulingFlow;
    if (schedulingFlowState.localState.isBrickAndMortarVisit
        && !(schedulingFlowState === null || schedulingFlowState === void 0 ? void 0 : schedulingFlowState.selectedDrawPlaceID))
        return ['Lab selection is required'];
    return null;
};
const getSchedulingFlowVisitOverviewStepFailures = (_route) => {
    var _a;
    const store = getStore();
    const schedulingFlowState = store.state.schedulingFlow;
    const { draftWaypoint, localState, primaryContact, selectedTimeSlot } = schedulingFlowState;
    if (!primaryContact)
        return ['Point of contact is required'];
    if (primaryContact.custom && !primaryContact.name) {
        return ['Point of contact name is required'];
    }
    if (primaryContact.custom && (!((_a = primaryContact.phone) === null || _a === void 0 ? void 0 : _a.number))) {
        return ['Point of contact phone number is required'];
    }
    if (!store.state.schedulingFlow.localState.phoneNumberIsValid) {
        return ['Point of contact phone number is invalid'];
    }
    const { isBrickAndMortarVisit } = localState;
    const isAppointmentOnlyVariant = store.getters['schedulingFlow/getIsAppointmentOnlyVariant'];
    if (isBrickAndMortarVisit
        && !isAppointmentOnlyVariant
        && !(draftWaypoint === null || draftWaypoint === void 0 ? void 0 : draftWaypoint.finalizedDate)) {
        return ['Date is required'];
    }
    if (!isBrickAndMortarVisit && !selectedTimeSlot) {
        return ['No time slot selected'];
    }
    return null;
};
const getSchedulingFlowCompleteProfileStepFailures = (_route) => {
    const store = getStore();
    const { patientInitiatedUserProfile } = store.state.schedulingFlow;
    if (Object.values(patientInitiatedUserProfile).some((field) => !field))
        return ['All fields are required'];
    return null;
};
const getSchedulingFlowPracticeInfoStepFailures = (_route) => {
    const store = getStore();
    const { practiceInfo } = store.state.schedulingFlow;
    if (Object.values(practiceInfo).some((field) => !field))
        return ['All fields are required'];
    return null;
};
const getSchedulingFlowWalkInDateStepFailures = (_route) => {
    var _a;
    const store = getStore();
    const finalizedDate = (_a = store.state.schedulingFlow.draftWaypoint) === null || _a === void 0 ? void 0 : _a.finalizedDate;
    if (!finalizedDate)
        return ['You must select a date'];
    return null;
};
/**
 * Validators to determine when the `Next` button should be enabled on
 * order flow steps.
 */
const schedulingFlowStepValidators = {
    [SchedulingFlowRouteName.SCHEDULING_FLOW_ADDRESS]: getSchedulingFlowAddressStepFailures,
    [SchedulingFlowRouteName.SCHEDULING_FLOW_FLEXIBLE_OPTION]: getSchedulingFlowFlexibleOptionStepFailures,
    [SchedulingFlowRouteName.SCHEDULING_FLOW_DATE_RANGE]: getSchedulingFlowDateRangeStepFailures,
    [SchedulingFlowRouteName.SCHEDULING_FLOW_TIME_RANGE]: getSchedulingFlowTimeRangeStepFailures,
    [SchedulingFlowRouteName.SCHEDULING_FLOW_TIME]: getSchedulingFlowTimeStepFailures,
    [SchedulingFlowRouteName.SCHEDULING_FLOW_WALK_IN_DATE]: getSchedulingFlowWalkInDateStepFailures,
    [SchedulingFlowRouteName.SCHEDULING_FLOW_VISIT_OVERVIEW]: getSchedulingFlowVisitOverviewStepFailures,
    [SchedulingFlowRouteName.SCHEDULING_FLOW_COMPLETE_PROFILE]: getSchedulingFlowCompleteProfileStepFailures,
    [SchedulingFlowRouteName.SCHEDULING_FLOW_PRACTICE_INFO]: getSchedulingFlowPracticeInfoStepFailures,
};

export { schedulingFlowStepValidators };
